const chipsExpiredServices = {
  from: 'From',
  to: 'To',
  mandatory: 'Mandatory Services',
  nonMandatory: 'Optional Services',
};

export default chipsExpiredServices;